import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { SupportedTicker } from '@/constants/token'
import { isSupportedTicker } from '@/utils'

const useQueryToken = (onChange: (value: SupportedTicker) => void) => {
  const { query } = useRouter()
  useEffect(() => {
    if (isSupportedTicker(query?.token) && typeof query?.token === 'string') {
      onChange(query?.token as SupportedTicker)
    }
  }, [onChange, query?.token])
}

export default useQueryToken
